const reverseEnumMapping = (Enum: Record<string, string>, value: string) => {
  let keys = Object.keys(Enum).filter((x) => Enum[x] == value);
  return keys.length > 0 ? keys[0] : "";
};
export default reverseEnumMapping;
